/**
 * PartsCutter Modern UI
 * نفس كل الوظائف والخيارات - تصميم جديد 100%
 * 
 * هذا Component يستخدم PartsCutter الأصلي مع كل وظائفه
 * لكن مع styled-components wrapper جديد تماماً يغير التصميم فقط
 */
import React from 'react';
import styled from 'styled-components';
import PartsCutterOriginal from './index';
import { lightTheme } from '../../ui/design/theme';

/**
 * Modern Wrapper - يغلف PartsCutter الأصلي بتصميم جديد
 */
const ModernWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.background || '#f8f9fa'};
  overflow: hidden;
  
  /* نضيف بعض التحسينات على التصميم */
  & > * {
    /* نستخدم theme الجديد */
    --primary-color: ${props => props.theme.primary || '#007bff'};
    --border-color: ${props => props.theme.border || '#dee2e6'};
    --surface-color: ${props => props.theme.surfaceElevated || '#ffffff'};
    --text-color: ${props => props.theme.text || '#212529'};
  }
`;

/**
 * Wrapper Component
 * يستخدم PartsCutter الأصلي مع كل وظائفه
 * لكن مع styled-components wrapper جديد تماماً
 */
const PartsCutterModern = (props) => {
  return (
    <ModernWrapper theme={lightTheme}>
      <PartsCutterOriginal {...props} />
    </ModernWrapper>
  );
};

export default PartsCutterModern;
